import React from 'react'
import { Divider, Stack } from '@mui/material'

import Header from './Header'
import Content from './Content'
import { FragmentType, graphql, useFragment } from '@/generated/gql'

const canteenCartTopUpCurrentMenuDataFragment = graphql(`
  fragment CanteenCartTopUp_CurrentMenuDataFragment on CCMealService {
    ...CanteenCartTopUpHeader_CurrentMenuDataFragment
    ...CanteenCartTopUpContent_CurrentMenuDataFragment
  }
`)

const canteenCartTopUpUserDataFragment = graphql(`
  fragment CanteenCartTopUp_UserDataFragment on User {
    ...CanteenCartTopUpHeader_UserDataFragment
    ...CanteenCartTopUpContent_UserDataFragment
  }
`)

type Props = {
  onBackClicked: () => void
  onCheckoutClicked: (bundle: number) => void
  loading: boolean
  cartTotal: number
  userData: FragmentType<typeof canteenCartTopUpUserDataFragment>
  currency: string
  menuData: FragmentType<typeof canteenCartTopUpCurrentMenuDataFragment>
}

const TopUp: React.FC<Props> = ({
  userData: userDataProp,
  menuData: menuDataProp,
  onBackClicked,
  onCheckoutClicked,
  cartTotal,
  loading,
  currency,
}) => {
  const userData = useFragment(canteenCartTopUpUserDataFragment, userDataProp)
  const menuData = useFragment(canteenCartTopUpCurrentMenuDataFragment, menuDataProp)
  return (
    <Stack spacing={3} direction="column" height="100vh" width="100%">
      <Stack direction="column">
        <Header userData={userData} menuData={menuData} onBackClicked={onBackClicked} />
        <Divider />
      </Stack>
      <Content
        currency={currency}
        userData={userData}
        menuData={menuData}
        onCheckoutClicked={onCheckoutClicked}
        cartTotal={cartTotal}
        loading={loading}
      />
    </Stack>
  )
}

export default TopUp
